import React,{useEffect, useRef} from 'react'
import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import ConfirmDialog from '../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';

import EssWorkReportForm from '../component/EssWorkReportForm';
import essWorkReportServices from '../essWorkReportServices';
import EssLayout from '../../../../layout/components/ESSLayout';


const CellActions = (props) =>{
    return(
        <>
            <EssWorkReportForm callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function EssWorkReportPage() {

  
  const [workReportList,setWorkReportList] = useState(null);
  const gridRef = useRef();
  

  const getWorkReport = () =>{
    essWorkReportServices.getList().then(res=>{
      setWorkReportList(res.data)
    }).catch(error=>{
      console.log(error);
    })
  }

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"report",headerName: "report",width:250},
        {field:"updated_at",headerName: "Date",width:250},
        
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getWorkReport,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <EssLayout>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-6'><h4>Daily Work report</h4></div>
          <div className='col-md-6'> 
            <span className='float-end'><EssWorkReportForm callBack={getWorkReport} /></span>
            <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
          </div>
          <div className='col-md-12 mt-2'>
            <div className="ag-theme-alpine" style={{height: 400}}>
                <AgGridReact
                  ref={gridRef}
                  rowData={workReportList}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  animateRows={true}
                  onGridReady={getWorkReport}
                />
              </div>
            </div>
          </div>
        </div>
    </EssLayout>
    
  )
}

export default EssWorkReportPage